export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10789.a55b4c9d.jpg";